












import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import "quill/dist/quill.snow.css";
import Quill from "quill";

import axios from "axios";
import { IMAGE_ENDPOINT } from "../../store/endpoints";
import { generateAuthHeader } from "../../utils/auth";
import { Getter } from "vuex-class";
import { ACCESS_TOKEN } from "../../store/getters.names";
import { API_HOST } from "../../global";
import { ImageUpload } from "quill-image-upload";
Quill.register("modules/imageUpload", ImageUpload);
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/ind
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }],
  ["image"], // dropdown with defaults fr
  [{ align: [] }],

  ["clean"] // remove formatting button
];
@Component({
  name: "RichTextEditor"
})
export default class RichTextEditor extends Vue {
  @Getter(ACCESS_TOKEN) atoken: string;
  @Prop() value: any;
  @Prop({ default: "" }) placeholder: string;
  editor: any = null;
  toolbar: any = null;
  userInput: boolean = false;

  get content(): string | null {
    if (this.editor == null) {
      return null;
    } else {
      this.editor.getContents();
    }
  }
  @Watch("value")
  handleValueChange(val, oldval) {
    // // console.log("value changed", this.userInput);
    if (!this.userInput) {
      // // console.log("changed");
      (this.$refs.editor as HTMLElement).querySelector(
        ".ql-editor"
      ).innerHTML = val;
    } else {
      this.userInput = false;
    }
  }
  mounted() {
    (this.$refs.editor as HTMLElement).innerHTML = this.value;
    // // console.log(this.$refs.editor);
    this.editor = new Quill(this.$refs.editor, {
      placeholder: this.placeholder,
      modules: {
        toolbar: toolbarOptions,
        imageUpload: {
          customUploader: (file, resolve) => {
            var rdata = new FormData();
            const authHeader = generateAuthHeader(this.atoken);
            rdata.append("image", file);
            // rdata.append("collection_id", null);
            axios
              .post(IMAGE_ENDPOINT, rdata, authHeader)
              .then(({ data }) => {
                axios
                  .patch(
                    `${IMAGE_ENDPOINT}${data.id}/`,
                    { published: true },
                    authHeader
                  )
                  .then(({ data }) => {
                    resolve(`${API_HOST}${data.published_path}`);
                  });
              })
              .catch(e => {
                // console.log(e);
              });
          }
        }
      },
      theme: "snow"
    });

    this.editor.on("text-change", (delta, oldDelta, source) => {
      if (source == "user") {
        this.userInput = true;
        this.$emit(
          "input",
          (this.$refs.editor as HTMLElement).querySelector(".ql-editor")
            .innerHTML
        );
      }
    });
  }
  beforeDestroy() {
    (this.$refs.container as HTMLElement).querySelector(".ql-toolbar").remove();
  }
}
